<template>
    <div>
        <h4>Confirm your changes</h4>
        <div class="confirmation-details">
            <p>
                <strong>Action:</strong>
                {{ actionName }}
            </p>
            <p v-if="selectedActionIndex === 0">
                <strong>Driver:</strong>
                {{ selectedDriverName }}
            </p>
            <p v-if="selectedActionIndex === 1">
                <strong>Status:</strong>
                {{ selectedStatus }}
            </p>
            <p v-if="selectedActionIndex === 2">
                <strong>Note Type:</strong>
                {{ selectedNoteType }}
            </p>
            <p v-if="selectedActionIndex === 2">
                <strong>Note:</strong>
                {{ selectedNote }}
            </p>
            <p v-if="selectedActionIndex === 5">
                <strong>Date:</strong>
                {{ formattedDate }}
            </p>
            <p>
                <strong>Records affected:</strong>
                {{ selectedRows.length + ' selected records' }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConfirmBulkAction',
    props: {
        selectedRows: {
            type: Array,
            required: true
        },
        selectedDriverId: {
            type: String,
            default: ''
        },
        selectedStatus: {
            type: String,
            default: ''
        },
        selectedNote: {
            type: String,
            default: ''
        },
        selectedNoteType: {
            type: String,
            default: 'Stop Note'
        },
        selectedDate: {
            type: [Date, String, null],
            default: null
        },
        selectedActionIndex: {
            type: Number,
            default: 0
        },
        teamMembers: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        actionName() {
            if (this.selectedActionIndex === 0) {
                return 'Assign to Driver';
            }
            if (this.selectedActionIndex === 1) {
                return 'Change Status';
            }
            if (this.selectedActionIndex === 2) {
                return 'Add Stop Note';
            }
            if (this.selectedActionIndex === 3) {
                return 'Delete';
            }
            if (this.selectedActionIndex === 4) {
                return 'Unassign';
            }
            if (this.selectedActionIndex === 5) {
                return 'Set Date';
            }
            return '';
        },
        formattedDate() {
            if (!this.selectedDate) {
                return 'No date (clearing existing date)';
            }
            return new Date(this.selectedDate).toLocaleDateString();
        },
        selectedDriverName() {
            if (!this.selectedDriverId) {
                return 'Unassign';
            }
            const driver = this.teamMembers.find((d) => d.publicUserId === this.selectedDriverId);

            return driver ? driver.fullName : '';
        }
    }
};
</script>

<style lang="scss" scoped>
.confirmation-details {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f5f5;
    border-radius: 4px;
}
</style>
